export default __webpack_public_path__ + "static/media/cart4hover.c828cafe.jpg";